<template>
    <div
        class="card custom-card card-builder"
        :class="active == true ? 'active' : ''"
    >
        <div
            class="logo"
            :style="{
                'background-image':
                    'url(' +
                    require('@/assets/images/data-image/' + logo + '') +
                    ')',
            }"
        >
            <img :src="require('@/assets/images/data-image/' + logo + '')" />
        </div>
        <h4>{{ name }}</h4>
        <p v-if="lastUpdate">{{ lastUpdate }}</p>
        <p v-if="totalRecord">{{ totalRecord }}</p>
        <p v-if="description" class="caption-description">{{ description }}</p>
    </div>
</template>
<script>
export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        logo: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },

        lastUpdate: {
            type: String,
            default: null,
        },

        totalRecord: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        active: {
            type: Boolean,
            default: false,
        },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {}
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {}, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
